export default __webpack_public_path__ + "static/media/upArrow.dcca261f.svg";